/* eslint-disable react/prop-types */
import React from "react";
import { css } from "@emotion/core";
import { StaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

export default ({ cssProp }) => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(
          relativePath: { eq: "journal/products/journal-product-shot-2.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 600) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        loading="eager"
        css={css`
          position: absolute !important;
          width: 100%;
          top: 0;
          bottom: 0;
          left: 0;
          margin: 0 auto;
          ${cssProp}
        `}
        fluid={data.placeholderImage.childImageSharp.fluid}
      />
    )}
  />
);
